export const PLATFORM_OPERATION_SYSTEM = {
  ANDROID: 'android',
  IOS: 'ios',
}
